import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { useNavigate, useLocation } from 'react-router-dom';
import { FaCheck, FaArrowLeftLong } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { SlCloudUpload } from 'react-icons/sl';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  FormLabel,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Swal from 'sweetalert2';

import axios from 'axios';
import appConfig from '../../config';
import { bnbDetail, createUser, updateBnbList, updateUser, uploadFile } from '../../helper/backend_helper';
import Iconify from '../iconify';

const BnBDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [bnbData, setBnBData] = useState({});
  console.log(bnbData);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    try {
      setLoading(true);
      const res = await bnbDetail();
      console.log(res?.data?.results);
      // Sort the data alphabetically by BnBShortName
      const sortedData = res?.data?.results?.sort((a, b) => {
        const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle case sensitivity and undefined
        const nameB = b.BnBShortName?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
      });

      setBnBData(sortedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);
  const attributes = bnbData?.length ? Object.keys(bnbData[0]).filter((key) => key !== 'BnBShortName') : [];
  return (
    <>
      <Helmet>
        <title>BnB Detail </title>
      </Helmet>
      <Card sx={{ padding: 2 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          {/* <FaArrowLeftLong size={24} /> */}
          <Typography variant="h4">BnB Configurations</Typography>
        </Stack>

        {loading ? (
          <CircularProgress size={18} />
        ) : (
          <TableContainer component={Paper} style={{ maxHeight: '80vh' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>BnB Name</strong>
                  </TableCell>
                  {attributes?.map((attribute) => (
                    <TableCell key={attribute} align="center">
                      {attribute}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {bnbData?.length > 0 ? (
                  bnbData?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {row.BnBShortName}
                      </TableCell>
                      {attributes.map((attribute) => (
                        <TableCell key={attribute} align="center">
                          {row[attribute] ? '✅' : '❌'}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={attributes.length + 1}>
                      <Typography variant="subtitle1">No data available</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Card>
    </>
  );
};

export default BnBDetail;
